// ============================================
// 📱 APP: NVA (React App)
// 📄 FILE: src/lib/bookingClaimStorage.ts
// 🔧 PURPOSE: La richiesta di collegamento prenotazione resta sul telefono
//             (localStorage): la pagina "Collega la tua prenotazione" la
//             scrive, il modal del login la rilegge per mostrare l'esito
//             (in verifica / collegata / rifiutata). Dopo un mese il record
//             non serve più: il soggiorno è passato o la richiesta è stata
//             dimenticata.
// ============================================

const CLAIM_STORAGE_KEY = 'nva_booking_claim';
const CLAIM_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

export interface StoredClaim {
  requestId: string;
  email: string;
  savedAt: number;
}

// Ogni accesso allo storage è protetto: in navigazione privata o con i
// cookie bloccati `localStorage` lancia, e il login non deve morire per questo.
export const readStoredClaim = (): StoredClaim | null => {
  try {
    const raw = window.localStorage.getItem(CLAIM_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<StoredClaim>;
    if (!parsed || typeof parsed.requestId !== 'string' || typeof parsed.email !== 'string') return null;
    const claim = { requestId: parsed.requestId, email: parsed.email, savedAt: Number(parsed.savedAt) || 0 };
    if (Date.now() - claim.savedAt > CLAIM_MAX_AGE_MS) {
      clearStoredClaim();
      return null;
    }
    return claim;
  } catch (err) {
    return null;
  }
};

export const writeStoredClaim = (claim: StoredClaim): void => {
  try {
    window.localStorage.setItem(CLAIM_STORAGE_KEY, JSON.stringify(claim));
  } catch (err) {
    /* storage non disponibile: si perde solo il banner */
  }
};

export const clearStoredClaim = (): void => {
  try {
    window.localStorage.removeItem(CLAIM_STORAGE_KEY);
  } catch (err) {
    /* niente da fare */
  }
};
